import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên nhóm CheckIn", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian CheckIn sáng", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian CheckOut sáng", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian CheckIn chiều", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Thời gian CheckOut chiều", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Tạo nhóm", -1)
const _hoisted_14 = { class: "p-fluid" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Không có thông tin nhóm. ")
const _hoisted_16 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhân viên", -1)
const _hoisted_19 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm", -1)
const _hoisted_21 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "Thêm nhân viên", -1)
const _hoisted_23 = { class: "p-fluid" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Không có thông tin tài khoản. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withCtx(() => [
      _createVNode(_component_AccordionTab, { header: "Thêm nhóm CheckIn" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                id: "name",
                type: "text",
                modelValue: $setup.groupCheckIn.groupName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.groupCheckIn.groupName) = $event)),
                placeholder: "Tên nhóm"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                modelValue: $setup.groupCheckIn.timeCheckInMorning,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.groupCheckIn.timeCheckInMorning) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                modelValue: $setup.groupCheckIn.timeCheckOutMorning,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.groupCheckIn.timeCheckOutMorning) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                modelValue: $setup.groupCheckIn.timeCheckInAfternoon,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.groupCheckIn.timeCheckInAfternoon) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_InputNumber, {
                inputId: "integeronly",
                modelValue: $setup.groupCheckIn.timeCheckOutAfternoon,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.groupCheckIn.timeCheckOutAfternoon) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Button, {
                label: "Tạo",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.createGroupCheckIn())),
                disabled: !$setup.groupCheckIn.groupName
              }, null, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_Panel, { header: "Danh sách nhóm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_DataTable, {
                  value: $setup.listGroupCheckIn,
                  paginator: true,
                  stripedRows: "",
                  rows: 10,
                  rowsPerPageOptions: [10,25,50],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['groupName'],
                  currentPageReportTemplate: "Có tất cả {totalRecords} nhóm",
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event))
                }, {
                  paginatorLeft: _withCtx(() => []),
                  empty: _withCtx(() => [
                    _hoisted_15
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "groupName",
                      header: "Tên nhóm",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "timeCheckInMorning",
                      header: "Thời gian CheckIn sáng",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "timeCheckOutMorning",
                      header: "Thời gian CheckOut sáng",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "timeCheckInAfternoon",
                      header: "Thời gian CheckIn chiều",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "timeCheckOutAfternoon",
                      header: "Thời gian CheckOut chiều",
                      sortable: ""
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_AccordionTab, { header: "Thêm nhân viên vào nhóm" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.updateEmployee.idEmployee,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.updateEmployee.idEmployee) = $event)),
                options: $setup.listEmployeeCheckIn,
                optionLabel: "fullName",
                optionValue: "id",
                filter: true
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.updateEmployee.idGroup,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.updateEmployee.idGroup) = $event)),
                options: $setup.listGroupCheckIn,
                optionLabel: "groupName",
                optionValue: "id",
                filter: true,
                onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.getListEmployeeGroup($setup.updateEmployee.idGroup)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateEmployeeGroups())),
                disabled: !$setup.updateEmployee.idEmployee||!$setup.updateEmployee.idGroup
              }, null, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_Panel, { header: "Danh sách nhân viên trong nhóm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_DataTable, {
                  value: $setup.listEmployeeCheckInGroup,
                  paginator: true,
                  stripedRows: "",
                  rows: 10,
                  rowsPerPageOptions: [10,25,50],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['fullName','phoneNumber','departmentsName'],
                  currentPageReportTemplate: "Có tất cả {totalRecords} tài khoản",
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters) = $event))
                }, {
                  paginatorLeft: _withCtx(() => []),
                  empty: _withCtx(() => [
                    _hoisted_24
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "fullName",
                      header: "Tên nhân viên",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "phoneNumber",
                      header: "Số điện thoại",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "departmentsName",
                      header: "Khoa/phòng",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "groupName",
                      header: "Tên nhóm CheckIn",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "",
                      header: "Xóa thành viên"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          class: "p-button-danger",
                          label: "Xóa",
                          icon: "pi pi-trash",
                          onClick: ($event: any) => ($setup.deleteEmployeeGroup(slotProps.data.id)),
                          style: {"font-size":"13px"}
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}